import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useWaveAuth } from '../../context/WaveAuthContext';

function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useWaveAuth();
  const location = useLocation();

  console.log('ProtectedRoute - isAuthenticated:', isAuthenticated, 'isLoading:', isLoading);

  // Don't redirect while checking auth status
  if (isLoading) {
    return (
      <div className="loading" style={{ textAlign: 'center', padding: '40px' }}>
        <h2>Loading...</h2>
      </div>
    );
  }

  // Only redirect if we're sure they're not authenticated
  if (!isAuthenticated) {
    console.log('ProtectedRoute - Not authenticated, redirecting to /wave-auth');
    return <Navigate to="/wave-auth" state={{ from: location.pathname }} replace />;
  }

  return children;
}

export default ProtectedRoute; 